import React from 'react'
import { visibleQuestions } from './remoteUnlockApi'
import { RuQuestion, RuChoice } from './RuPrimitives'

/** missing = visible questions that are required and unanswered */
export function missingAnswers(questions, answers, visible = null) {
  return (visible || visibleQuestions(questions, answers))
    .filter(q => q.required !== false && !String(answers[q.id] ?? '').trim())
    .map(q => q.id)
}

/** visible questions + their answer label → for summaries */
export function answerSummary(questions, answers, visible = null) {
  return (visible || visibleQuestions(questions, answers)).map(q => ({
    id: q.id,
    text: q.text,
    label: q.options.length ? (q.options.find(o => o.id === answers[q.id])?.label || '—') : (answers[q.id] || '—'),
    isChoice: q.options.length > 0,
  }))
}

/**
 * Renders get-checklist questions. Dependent questions only appear once their
 * parent has the triggering answer (see visibleQuestions).
 */
export default function ChecklistFields({
  questions, answers, onChange, showErrors, namePrefix, disabled, visible: visibleOverride = null, hints = {}, notes = {},
}) {
  const visible = visibleOverride || visibleQuestions(questions, answers)
  const missing = showErrors ? missingAnswers(questions, answers, visible) : []
  return visible.map((q, i) => (
    <RuQuestion
      key={q.id} index={i + 1} text={q.text} hint={q.hint}
      error={missing.includes(q.id) ? 'This question is required.' : ''}
    >
      {q.options.length && ['dropdown', 'select'].includes(q.type) ? (
        <select
          className="ru-select" value={answers[q.id] || ''} disabled={disabled}
          onChange={e => onChange(q.id, e.target.value)}
        >
          <option value="">Select…</option>
          {q.options.map(o => <option key={o.id} value={o.id}>{o.label}</option>)}
        </select>
      ) : q.options.length ? (
        <div className="ru-choices">
          {q.options.map(o => (
            <RuChoice
              key={o.id} name={`${namePrefix}-${q.id}`} label={o.label}
              checked={answers[q.id] === o.id} disabled={disabled}
              onChange={() => onChange(q.id, o.id)}
            />
          ))}
        </div>
      ) : (
        <textarea
          className="ru-textarea" rows={2} value={answers[q.id] || ''} disabled={disabled}
          onChange={e => onChange(q.id, e.target.value)}
          placeholder="Type your answer…"
        />
      )}
      {hints[q.id] && <div className={`ru-hint ${hints[q.id].tone || ''}`}>{hints[q.id].text}</div>}
      {notes[q.id] && (
        <div className="ru-note-warn"><span aria-hidden>⚠</span><div><b>{notes[q.id].label}</b> {notes[q.id].text}</div></div>
      )}
    </RuQuestion>
  ))
}
